import { boot } from "./game";

const canvas = document.getElementById("game") as HTMLCanvasElement | null;
if (!canvas) throw new Error("missing #game");
canvas.tabIndex = 0;
void boot(canvas);
